import React, { useState } from 'react';
import { ArrowLeftIcon, MailIcon } from 'lucide-react';
import Avatar from '../components/shared/Avatar';
import Button from '../components/shared/Button';
const NotificationsPage = () => {
  const [activeTab, setActiveTab] = useState('all');
  const tabs = [{
    id: 'all',
    name: 'All'
  }, {
    id: 'mentions',
    name: 'Mentions'
  }, {
    id: 'solicitations',
    name: 'Solicitations'
  }];
  const notifications = [{
    id: '1',
    type: 'follow',
    user: {
      name: 'Cristiano Ronaldo',
      username: 'cristiano',
      avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61',
      verified: true,
      role: 'Player'
    },
    time: '2h',
    read: false
  }, {
    id: '2',
    type: 'like',
    user: {
      name: 'FC Barcelona',
      username: 'fcbarcelona',
      avatar: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20',
      verified: true,
      role: 'Club'
    },
    content: 'your post',
    time: '5h',
    read: false
  }, {
    id: '3',
    type: 'comment',
    user: {
      name: 'Serena Williams',
      username: 'serenawilliams',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80',
      verified: true,
      role: 'Player'
    },
    content: 'Great technique!',
    time: '1d',
    read: true
  }, {
    id: '4',
    type: 'mention',
    user: {
      name: 'NBA',
      username: 'nba',
      avatar: 'https://images.unsplash.com/photo-1574623452334-1e0ac2b3ccb4',
      verified: true,
      role: 'League'
    },
    content: 'mentioned you in a post',
    time: '2d',
    read: true
  }, {
    id: '5',
    type: 'solicitation',
    user: {
      name: 'Real Madrid',
      username: 'realmadrid',
      avatar: 'https://images.unsplash.com/photo-1589487391730-58f20eb2c308',
      verified: true,
      role: 'Club'
    },
    content: 'sent you a tryout request',
    time: '3d',
    read: true
  }];
  const solicitations = [{
    id: '1',
    type: 'tryout',
    user: {
      name: 'Real Madrid',
      username: 'realmadrid',
      avatar: 'https://images.unsplash.com/photo-1589487391730-58f20eb2c308',
      verified: true,
      role: 'Club'
    },
    content: 'We would like to invite you for a tryout session with our youth team.',
    date: 'June 15, 2024',
    location: 'Madrid, Spain',
    time: '3d',
    status: 'pending'
  }, {
    id: '2',
    type: 'sponsorship',
    user: {
      name: 'Nike',
      username: 'nike',
      avatar: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff',
      verified: true,
      role: 'Sponsor'
    },
    content: 'We are interested in discussing a potential sponsorship opportunity with you.',
    time: '1w',
    status: 'pending'
  }];
  const filteredNotifications = activeTab === 'all' ? notifications : activeTab === 'mentions' ? notifications.filter(n => n.type === 'mention') : [];
  return <div className="bg-white min-h-full pb-16" data-id="element-788">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200" data-id="element-789">
        <div className="flex items-center" data-id="element-790">
          <button className="text-gray-800 mr-2" data-id="element-791">
            <ArrowLeftIcon size={24} data-id="element-792" />
          </button>
          <h1 className="text-xl font-semibold" data-id="element-793">Notifications</h1>
        </div>
        <button className="text-gray-800" data-id="element-794">
          <MailIcon size={24} data-id="element-795" />
        </button>
      </div>
      {/* Tabs */}
      <div className="flex border-b border-gray-200" data-id="element-796">
        {tabs.map(tab => <button key={tab.id} className={`flex-1 py-3 text-sm font-medium ${activeTab === tab.id ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} onClick={() => setActiveTab(tab.id)} data-id="element-797">
            {tab.name}
            {tab.id === 'solicitations' && <span className="ml-1 bg-red-500 text-white text-xs px-1.5 rounded-full" data-id="element-798">
                {solicitations.length}
              </span>}
          </button>)}
      </div>
      {/* Notifications List */}
      {activeTab !== 'solicitations' && <div className="divide-y divide-gray-100" data-id="element-799">
          {filteredNotifications.map(notification => <div key={notification.id} className={`flex items-center p-4 ${!notification.read ? 'bg-blue-50' : ''}`} data-id="element-800">
              <Avatar src={notification.user.avatar} size="md" data-id="element-801" />
              <div className="ml-3 flex-1" data-id="element-802">
                <div className="flex items-start" data-id="element-803">
                  <div className="flex-1" data-id="element-804">
                    <p className="text-sm" data-id="element-805">
                      <span className="font-semibold" data-id="element-806">
                        {notification.user.username}
                      </span>
                      {notification.type === 'follow' && ' started following you'}
                      {notification.type === 'like' && ' liked your post'}
                      {notification.type === 'comment' && ` commented: "${notification.content}"`}
                      {notification.type === 'mention' && ' mentioned you in a post'}
                      {notification.type === 'solicitation' && ' sent you a tryout request'}
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-807">
                      {notification.time}
                    </p>
                  </div>
                  {notification.type === 'follow' && <Button variant="outline" size="sm" data-id="element-808">
                      Follow
                    </Button>}
                </div>
              </div>
            </div>)}
        </div>}
      {/* Solicitations List */}
      {activeTab === 'solicitations' && <div className="p-4 space-y-4" data-id="element-809">
          {solicitations.map(solicitation => <div key={solicitation.id} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm" data-id="element-810">
              <div className="flex items-center" data-id="element-811">
                <Avatar src={solicitation.user.avatar} size="md" data-id="element-812" />
                <div className="ml-3" data-id="element-813">
                  <div className="flex items-center" data-id="element-814">
                    <span className="font-semibold text-sm" data-id="element-815">
                      {solicitation.user.name}
                    </span>
                    {solicitation.user.verified && <svg className="w-3 h-3 text-blue-500 ml-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-816">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-817"></path>
                      </svg>}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-818">
                    <span data-id="element-819">{solicitation.user.role}</span>
                    <span className="mx-1" data-id="element-820">•</span>
                    <span data-id="element-821">{solicitation.time} ago</span>
                  </div>
                </div>
              </div>
              <div className="mt-3" data-id="element-822">
                <div className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full inline-block mb-2" data-id="element-823">
                  {solicitation.type === 'tryout' ? 'Tryout Request' : 'Sponsorship Offer'}
                </div>
                <p className="text-sm" data-id="element-824">{solicitation.content}</p>
                {solicitation.date && <div className="mt-2 text-xs text-gray-600" data-id="element-825">
                    <p data-id="element-826">
                      <span className="font-medium" data-id="element-827">Date:</span>{' '}
                      {solicitation.date}
                    </p>
                    <p data-id="element-828">
                      <span className="font-medium" data-id="element-829">Location:</span>{' '}
                      {solicitation.location}
                    </p>
                  </div>}
              </div>
              <div className="mt-4 flex space-x-2" data-id="element-830">
                <Button variant="primary" size="sm" fullWidth data-id="element-831">
                  Accept
                </Button>
                <Button variant="outline" size="sm" fullWidth data-id="element-832">
                  Decline
                </Button>
              </div>
            </div>)}
        </div>}
    </div>;
};
export default NotificationsPage;